var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabIconBookingReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.2 5.5c.58 0 1.05.47 1.05 1.05v1.47h3.15c.58 0 1.05.47 1.05 1.05v13.65c0 .58-.47 1.05-1.05 1.05H7.6c-.58 0-1.05-.47-1.05-1.05V9.07c0-.58.47-1.05 1.05-1.05h3.15V6.55c0-.58.47-1.05 1.05-1.05.58 0 1.05.47 1.05 1.05v1.47h6.3V6.55c0-.58.47-1.05 1.05-1.05zm-.105 7.126c-.382-.375-.978-.399-1.386-.075l-.098.089-3.647 3.715-1.574-1.604-.099-.089c-.408-.324-1.004-.3-1.386.074-.382.375-.417.97-.1 1.386l.085.1 3.074 3.132 5.145-5.244.087-.1c.316-.414.281-1.01-.1-1.384z"
  })));
}
export default SvgTabIconBookingReview;